import { RETRIEVE_PRODUCT_OWNER_REPORT } from '../../actions/types';

const initialState = {
    companies: [],
    plants: [],
    products: [],
    cases: [],
    statuses: [],
    page: 1,
    limit: 10,
    total: 0,
};

function productOwnerReducer(reports = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case RETRIEVE_PRODUCT_OWNER_REPORT:
            return payload;
        default:
            return reports;
    }
}

export default productOwnerReducer;
